import { Sine, TimelineLite } from "gsap";
import * as HLF from "html-living-framework";
import * as Constants from "../../Data/Constants";

export class Lantern extends PIXI.Sprite {
    private static readonly BOB_DIST: PIXI.Point = new PIXI.Point(10, 20);
    private static readonly BOB_DUR: PIXI.Point = new PIXI.Point(1.5, 3.0);

    private _timeline!: TimelineLite;

    constructor(pIndex: number) {
        super(PIXI.loader.resources[Constants.SPRITESHEET_OBSTACLE_PREFIX + "00"].textures!["lantern-0" + pIndex]);
        this.anchor.set(0, 0.5);

        this.animate();
        this.stagger();
    }

    public destroy(pOptions: boolean | PIXI.DestroyOptions = { children: true }): void {
        this._timeline.kill();
    }

    private animate(): void {
        if (this._timeline !== undefined) {
            this._timeline.kill();
        }
        this._timeline = new TimelineLite();
        this._timeline.to(this, HLF.Random.floatBetweenPoint(Lantern.BOB_DUR), {
            y: -HLF.Random.floatBetweenPoint(Lantern.BOB_DIST),
            ease: Sine.easeInOut,
        });
        this._timeline.to(this, HLF.Random.floatBetweenPoint(Lantern.BOB_DUR), {
            y: HLF.Random.floatBetweenPoint(Lantern.BOB_DIST),
            ease: Sine.easeInOut,
        });
        this._timeline.call(this.animate.bind(this));
    }

    private stagger(): void {
        this._timeline.totalProgress(HLF.Random.floatBetween(0, 0.9));
    }
}
